/* eslint-disable react/jsx-no-target-blank */
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import { faArrowAltCircleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Project = ({ details }) => {
  const { name, url, client, Server } = details;
  return (
    <div className="card card-compact bg-base-100 shadow-xl">
      <figure>
        <div className="max-h-72 carousel carousel-vertical rounded-tr-lg rounded-tl-lg">
          {details.img.map((slide) => {
            return (
              <div className="carousel-item h-full min-w-full">
                <img src={slide} alt="" />
              </div>
            );
          })}
        </div>
      </figure>
      <div className="card-body">
        <h2 className="text-3xl">{name}</h2>
        <div className="grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-1 gap-5  justify-around items-center">
          {url && (
            <a
              target="_blank"
              className="btn bg-emerald-500 text-slate-900 btn-block hover:text-primary"
              href={url}
            >
              Live Website
            </a>
          )}
          {client && (
            <a
              target="_blank"
              className="btn bg-emerald-500 text-slate-900 btn-block hover:text-primary"
              href={client}
            >
              Client site repo
            </a>
          )}
          {Server && (
            <a
              target="_blank"
              className="btn bg-emerald-500 text-slate-900 btn-block hover:text-primary"
              href={Server}
            >
              Server site repo
            </a>
          )}
        </div>
        <span className="text-2xl font-normal text-accent">
          Features{" "}
          <FontAwesomeIcon
            className="text-primary"
            icon={faArrowAltCircleDown}
          />{" "}
        </span>
        <ul>
          {details.features.map((feature) => {
            return (
              <span>
                {" "}
                <FontAwesomeIcon
                  icon={faCircleCheck}
                  className="bg-emerald-500 text-slate-900 rounded-2xl text-sm"
                />{" "}
                <span className="text-sm">{feature} </span> <br />
              </span>
            );
          })}
        </ul>
        <span className="text-2xl font-normal text-accent">
          Technology{" "}
          <FontAwesomeIcon
            icon={faArrowAltCircleDown}
            className="text-primary"
          />
        </span>
        <div className="card-actions justify-end">
          {details.technology.map((tech) => {
            return <div className="badge badge-outline badge-sm">{tech}</div>;
          })}
        </div>
      </div>
    </div>
  );
};

export default Project;
